import React from 'react';
import { Box, Image, Text, VStack } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.8; }
`;

const fadeOut = keyframes`
  from { opacity: 1; visibility: visible; }
  to { opacity: 0; visibility: hidden; }
`;

const LoadingScreen = ({ isLoading }) => {
  const pulseAnimation = `${pulse} 2s infinite`;
  const fadeOutAnimation = `${fadeOut} 0.5s ease-out forwards`;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="#150d04"
      zIndex="9999"
      visibility={isLoading ? "visible" : "hidden"}
      opacity={isLoading ? 1 : 0}
      transition="opacity 0.5s ease-out"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={4}>
        <Box
          animation={pulseAnimation}
          filter="drop-shadow(0 0 12px var(--chakra-colors-brand-200))"
          opacity={isLoading ? 1 : 0}
          transition="opacity 0.3s"
        >
          <Image
            src="/images/logo.png"
            alt="Namaskar India Logo"
            w="80px"
            h="80px"
            objectFit="contain"
          />
        </Box>
        <Text
          bgGradient="linear(to-r, brand.400, terracotta.400)"
          bgClip="text"
          fontSize="xl"
          fontWeight="bold"
          letterSpacing="tight"
          opacity={isLoading ? 1 : 0}
          transition="opacity 0.3s"
        >
          Namaskar India
        </Text>
      </VStack>
    </Box>
  );
};

export default LoadingScreen;
